/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';
import { TrackingContext } from '@vrbo/react-event-tracking';
import TranslationUtil from '../../../utils/TranslationUtil';
import withPageFlow from '../../PageFlow/PageFlow';
import ExperimentUtil from '../../../utils/ExperimentUtil';

import lodgingIcon from '../../../assets/images/Lodging.svg';
import privateResidenceIcon from '../../../assets/images/PrivateResidence.svg';

import lodgingIconV2 from '../../../assets/images/lodging_v2.svg';
import privateResidenceIconV2 from '../../../assets/images/vr_v2.svg';

import {
    createPageViewEvent
} from '../../../utils/EventProviders/EgClickstreamUtil';
import { isRebrandingActive } from '../../../utils/ExperimentsUtil';
import { DomUtilsCtx } from '../../../contexts/domUtils';
import { LODGIN_TYPES } from '../../../actions/classification';

export const Classification = (props) => {
    const { trigger } = useContext(TrackingContext);

    const {
        referrer,
        analytics,
        mainTitle,
        lodgingPreferenceOption1,
        lodgingPreferenceOption2,
        lodPrefOpt1AddInfo,
        lodPrefOpt2AddInfo,
        isRebranded
    } = props;

    const iconLodging = isRebranded ? lodgingIconV2 : lodgingIcon;
    const iconVr = isRebranded ? privateResidenceIconV2 : privateResidenceIcon;
    useEffect(() => {
        trigger('pageLoad', {
            pageName: 'partner-qualifier: classification',
            referrer
        });
        trigger('pageview', createPageViewEvent('Classification'));
        analytics.setAnalyticsPageName('ClassificationStep');
        analytics.viewTTIstop();
        trigger('pageLoadGtm', {
            pageName: 'ClassificationStep',
            event: 'ClassificationStepLoad'
        });

        return () => {
            trigger('pageUnload', { referrer });
            analytics.viewTTIstart();
        };
    }, []);

    const {
        handleLodgingPreferenceChange
    } = useContext(DomUtilsCtx);

    return (
        <div className={classnames('classificationStep', 'ulx-animated')}>
            <p className="classification__title">{mainTitle}</p>
            <div className="classification__Options">
                <div className="classification__Options__outer">
                    <div
                        id="classification_lodging"
                        className="classification__Options__inner"
                        onClick={() => handleLodgingPreferenceChange(LODGIN_TYPES.CL)}
                        onKeyDown={() => handleLodgingPreferenceChange(LODGIN_TYPES.CL)}
                        role="presentation"
                    >
                        <div className="classification__Options__inner__img">
                            <img src={iconLodging} alt="Lodging" width={isRebranded ? '48' : '60'} height="48" />
                        </div>
                        <div className="classification__Options__inner__titleDiv">
                            <p className="classification__Options__inner__titleDiv__title">{lodgingPreferenceOption1}</p>
                            {
                                !isRebranded && <p className="classification__Options__inner__titleDiv__subtitle">{lodPrefOpt1AddInfo}</p>
                            }
                        </div>

                    </div>
                    <div
                        id="classification_privateResidence"
                        className="classification__Options__inner"
                        onClick={() => handleLodgingPreferenceChange(LODGIN_TYPES.VR)}
                        onKeyDown={() => handleLodgingPreferenceChange(LODGIN_TYPES.VR)}
                        role="presentation"
                    >
                        <div className="classification__Options__inner__img">
                            <img src={iconVr} alt="Private Residence" width={isRebranded ? '48' : '60'} height="48" />
                        </div>
                        <div className="classification__Options__inner__titleDiv">
                            <p className="classification__Options__inner__titleDiv__title">{lodgingPreferenceOption2}</p>
                            {
                                !isRebranded && <p className="classification__Options__inner__titleDiv__subtitle">{lodPrefOpt2AddInfo}</p>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Classification.propTypes = {
    referrer: PropTypes.string.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
    pageFlow: PropTypes.shape({
        next: PropTypes.func.isRequired
    }).isRequired,
    mainTitle: PropTypes.string.isRequired,
    lodgingPreferenceOption1: PropTypes.string.isRequired,
    lodgingPreferenceOption2: PropTypes.string.isRequired,
    lodPrefOpt1AddInfo: PropTypes.string.isRequired,
    lodPrefOpt2AddInfo: PropTypes.string.isRequired,
    analytics: PropTypes.shape({
        viewTTIstart: PropTypes.func,
        viewTTIstop: PropTypes.func,
        setAnalyticsPageName: PropTypes.func
    }).isRequired,
    isRebranded: PropTypes.bool.isRequired
};

/* istanbul ignore next */
const mapStateToProps = (state) => {
    const { app, joinDetails } = state;
    const { lodgingPreference } = joinDetails;
    const { referrer } = app;
    const experimentsUtil = new ExperimentUtil(app.experiments);
    const isRebranded = isRebrandingActive(experimentsUtil);
    const translations = new TranslationUtil(
        app.translations,
        app.fallbackTranslations
    );
    return {
        mainTitle: translations.getTranslation('classification_mainTitle'),
        lodgingPreferenceOption1: translations.getTranslation(
            'classification_lodgingPreferenceOption1'
        ),
        lodgingPreferenceOption2: translations.getTranslation(
            'classification_lodgingPreferenceOption2'
        ),
        lodPrefOpt1AddInfo: translations.getTranslation(
            'classification_lodPrefOpt1AddInfo'
        ),
        lodPrefOpt2AddInfo: translations.getTranslation(
            'classification_lodPrefOpt2AddInfo'
        ),
        notSureText: translations.getTranslation('classification_notSureText'),
        letUsHelpText: translations.getTranslation('classification_letusHelpText'),
        clLodgingPreferenceOption1: translations.getTranslation(
            'lyp.hero.classification.cl'
        ),
        clLodgingPreferenceOption2: translations.getTranslation(
            'lyp.hero.classification.vr'
        ),
        clLodPrefOpt1AddInfo: translations.getTranslation(
            'lyp.hero.classification.cl.subtitle'
        ),
        clLodPrefOpt2AddInfo: translations.getTranslation(
            'lyp.hero.classification.vr.subtitle'
        ),
        clCLCta: translations.getTranslation('lyp.hero.classification.cl.cta'),
        clVrCta: translations.getTranslation('lyp.hero.classification.vr.cta'),
        referrer,
        translations,
        lodgingPreference,
        isRebranded
    };
};

const ClassificationInfo = connect(
    mapStateToProps
)(Classification);
ClassificationInfo.displayName = 'ClassificationStep';
export default hot(module)(withPageFlow(ClassificationInfo));
